import accessoriesIcon from './accessories.svg';
import leafIcon from './Leaf.svg';
import checkedIcon from './checkedIcon.svg';
import addIcon from './add.svg';
import addIcon1 from './add_1.svg';
import addIcon2 from './add_2.svg';
import arrowBottomIcon from './arrow-bottom.svg';
import arrowBottomIcon1 from './arrow-bottom_1.svg';
import arrowDownIcon from './arrow-down.svg';
import arrowLeftIcon from './arrow-left.svg';
import arrowLeftIcon1 from './arrow-left_1.svg';
import arrowRightIcon from './arrow-right.svg';
import arrowRightIcon1 from './arrow-right_1.svg';
import arrowRightIcon2 from './arrow-right_2.svg';
import arrowTopIcon from './arrow-top.svg';
import arrowTopIcon1 from './arrow-top_1.svg';
import arrowUpIcon from './arrow-up.svg';
import cartIcon from './cart.svg';
import cartIcon1 from './cart_1.svg';
import cartAddIcon from './cart-add.svg';
import categoriesIcon from './categories.svg';
import categoriesIcon1 from './categories_1.svg';
import checkIcon from './check.svg';
import checkIcon1 from './check_1.svg';
import checkIcon2 from './check_2.svg';
import closeIcon from './close.svg';
import closeIcon1 from './close_1.svg';
import collapsedIcon from './collapsed.svg';
import copyIcon from './copy.svg';
import deleteIcon from './delete.svg';
import dotsIcon from './dots.svg';
import downloadIcon from './download.svg';
import editIcon from './edit.svg';
import errorIcon from './error.svg';
import expandedIcon from './expanded.svg';
import exportIcon from './export.svg';
import favoriteIcon from './favorite.svg';
import filterIcon from './filter.svg';
import forwardArrowIcon from './forward-arrow.svg';
import importIcon from './import.svg';
import infoIcon from './info.svg';
import linkedIcon from './linked.svg';
import listIcon from './list.svg';
import listIcon1 from './list_1.svg';
import listIcon2 from './list_2.svg';
import listIcon3 from './list_3.svg';
import listIcon4 from './list_4.svg';
import logoIcon from './logo.svg';
import menuIcon from './menu.svg';
import menuIcon1 from './menu_1.svg';
import minusIcon from './minus.svg';
import pinIcon from './pin.svg';
import profileIcon from './profile.svg';
import profileIcon1 from './profile_1.svg';
import resetIcon from './reset.svg';
import searchIcon from './search.svg';
import searchIcon1 from './search_1.svg';
import solutionsIcon from './solutions.svg';
import solutionsIcon1 from './solutions_1.svg';
import sortIcon from './sort.svg';
import starIcon from './star.svg';
import redStarIcon from './RedStar.svg';
import stockIcon from './stock.png';
import tileIcon from './tile.svg';
import tipsIcon from './tips.svg';
import tipsIcon1 from './tips_1.svg';
import uploadIcon from './upload.svg';
import warningIcon from './warning.svg';
import warningIcon1 from './warning_1.svg';
import windowsIcon from './windows.svg';
import wrenchesIcon from './wrenches.svg';
import CartIconNew from './carticon.png';
import ABBLogoPNG from './ABBLogo.png';
import ABBLogo from './abb-logo_white.svg';
import calculatorIcon from './calculator.svg';
import Language from './Language.png';
import ABBRedLogo from './abb-logo_red.svg';
import CartLogoNew from './cartIconNew.svg';
import VectorRightIconNew from './VectorRightIconNew.svg';
import VectorCartLogoNew from './16CartIconNew.svg';
import VectorArrowRightIconNew from './VectorarrowRightIconNew.svg';
import VectorMobileSearchIcon from './SearchIconNew.svg';
import VectorMobileTreeViewIcon from './VectorMobileTreeView.png';
import VectorMediaViewBlock from './VectorMediaViewBlock.png';
import VectorSearchArrowDownIcon from './VectorSearchArrowDownIcon.png';
import VectorCounterMinusIcon from './VectorCounterMinusIcon.png';
import VectorCounterPlusIcon from './VectorCounterPlusIcon.png';
import DeleteIconNew from "./16DeleteIconNew.svg";
import ImportIconNew from "./16ImportIconNew.svg";
import ExportIconNew from "./16ExportIconNew.svg";
import DeleteWhiteIconNew from "./DeleteWhiteIconNew.svg";
import EmptyStateIconNew from "./EmptyStateIconNew.svg";
import CloseIconNew from "./CloseIconNew.svg";
import ResetIconNew from "./ResetIconNew.svg"
import ProductDeailedView from "./ProductDetailedView.svg"
import ProductSimpleView from "./ProductSimpleView.svg";
import MenuIconNew from "./MenuIconNew.svg";
import ProductMenuIconNew from "./ProductMenuIconNew.svg";
import DuplicateIconNew from "./DuplicateIconNew.svg";
import TrashIconNew from "./TrashIconNew.svg";
import EditIConNew from "./EditIConNew.svg";
import FilterIconNew from "./FilterIconNew.svg";
import PinIconNew from "./PinIconNew.svg";
import ABBRedLogoPng from "./ABBRedLogo.png";
import ABBLogoSVG from './ABBRedLogoNew.svg';
import MinusIconNewSvg from "./MinusIconNewSvg.svg";
import MinusIconActive from "./MinusIconActive.svg";
import EmptySearchStateIcon from "./EmptySearchStateIcon.svg";
import WarningTriangleIconNew from "./WarningTriangleIconNew.svg";
import SettingsIconNew from "./SettingIconNew.svg";
import TrashWhiteIconNew from "./TrashWhiteIconNew.svg";
import MobileExcelImportIcon from "./MobieExcelImportIcon.svg";
import HelpImage from "./HelpImage.svg";
import InfoIconNew from "./InfoIconNew.svg";
import OpenInNewWindow from "./OpenInNewWindow.svg";
import OrangeWarningIconNew from "./WarningIconNew.svg";
import RedCheckMarkIconNew from "./RedCheckMarkIconNew.svg";
import WhiteCartIconNew from "./WhiteCartIconNew.svg";
import SelectedRadioIconNew from "./SelectedRadioIconNew.svg";
import NotSelectedRadioIconNew from "./NotSelectedRadioIconNew.svg";
import GreyFilterEmptyIconNew from "./GreyFilterEmptyIconNew.svg";
import CloseLightIconNew from "./CloseLightIconNew.svg";
import GreyDeleteIconNew from "./GreyDeleteIconNew.svg";
import DownArrowIconNew from "./DownArrowIconNew.svg";
import SearchIconNew from "./SearchIconNew.svg";
import ResetSearchIconNew from "./ResetSearchIconNew.svg";
import PathIndicatorNew from "./PathIndicatorNew.svg";
import ErrorIconNew from "./ErrorIconNew.svg";
import placeHoderImage from "./placeholder.jpg"
import closePopup from './close-popup.svg';
import linkedIconNew from './LinkedIconNew.svg'
import mobileClosePopup from './mobile-close-popup.svg';
import addonsInfoIcon from './add-ons-info-icon.svg'
import breadcrumIcon from './breadcrum-icon.svg';
import messageWarningIcon from './24messageWarningIcon.svg';
import messageSuccessIcon from './messageSuccessIcon.svg';
import messageErrorIcon from './messageErrorIcon.svg';
import productWarningIcon from './productWarningIcon.svg'
import NewSearchIcon from './NewSearchIcon.svg';
import NewArrowTopIcon from './NewArrowTopIcon.svg';
import newExpandButton from './newExpandButton.svg';
import caretDownIconNew from './CaretDownIconNew.svg';
import vectorArrowUpNew from './Vectorarrowup.png';
import tickIconNew from './tickIconNew.svg';
import readyAssemblyWaningIcon from './readyAssemblyWaningIcon.svg';
import GlobalIconNew from './GlobalIconNew.svg';
import LanguageTickIcon from './LanguageTickIcon.svg'
// import arrowExpanderIcon from './arrowExpanderIcon.svg';
// import arrowExpandedIcon from './arrowExpandedIcon.svg';
import Symbol_902 from './902.svg';
import Symbol_001 from './001.svg';
import Symbol_005 from './005.svg';
import Symbol_007 from './007.svg';
import Symbol_015 from './015.svg';
import Symbol_021 from './021.svg';
import Symbol_032 from './032.svg';
import Symbol_034 from './034.svg';
import Symbol_039 from './039.svg';
import Symbol_045 from './045.svg';
import Symbol_046 from './046.svg';
import Symbol_049 from './049.svg';
import Symbol_050 from './050.svg';
import Symbol_051 from './051.svg';
import Symbol_052 from './052.svg';
import Symbol_053 from './053.svg';
import Symbol_054 from './054.svg';
import Symbol_055 from './055.svg';
import Symbol_056 from './056.svg';
import Symbol_301 from './301.svg';
import Symbol_302 from './302.svg';
import Symbol_303 from './303.svg';
import Symbol_304 from './304.svg';
import Symbol_305 from './305.svg';
import Symbol_307 from './307.svg';
import Symbol_311 from './311.svg';
import Symbol_320 from './320.svg';
import Symbol_321 from './321.svg';
import Symbol_322 from './322.svg';
import Symbol_329 from './329.svg';
import Symbol_330 from './330.svg';
import Symbol_331 from './331.svg';
import Symbol_332 from './332.svg';
import Symbol_335 from './335.svg';
import Symbol_338 from './338.svg';
import Symbol_339 from './339.svg';
import Symbol_346 from './346.svg';
import Symbol_347 from './347.svg';
import Symbol_348 from './348.svg';
import Symbol_349 from './349.svg';
import Symbol_350 from './350.svg';
import Symbol_351 from './351.svg';
import Symbol_352 from './352.svg';
import Symbol_353 from './353.svg';
import Symbol_357 from './357.svg';
import Symbol_358 from './358.svg';
import Symbol_359 from './359.svg';
import Symbol_360 from './360.svg';
import Symbol_361 from './361.svg';
import Symbol_362 from './362.svg';
import Symbol_363 from './363.svg';
import Symbol_364 from './364.svg';
import Symbol_365 from './365.svg';
import Symbol_366 from './366.svg';
import Symbol_367 from './367.svg';
import Symbol_368 from './368.svg';
import Symbol_501 from './501.svg';
import Symbol_502 from './502.svg';
import Symbol_503 from './503.svg';
import Symbol_504 from './504.svg';
import Symbol_510 from './510.svg';
import Symbol_511 from './511.svg'; 
import Symbol_512 from './512.svg';
import Symbol_516 from './516.svg';
import Symbol_517 from './517.svg';
import Symbol_519 from './519.svg';
import Symbol_520 from './520.svg';
import Symbol_518 from './518.svg';
import Symbol_515 from './515.svg';
import Symbol_514 from './514.svg';
import Symbol_420 from './420.svg';
import Symbol_707 from './707.svg';
import Symbol_708 from './708.svg';
import Symbol_723 from './723.svg';
import Symbol_724 from './724.svg';
import Symbol_725 from './725.svg';
import Symbol_726 from './726.svg';
import Symbol_727 from './727.svg';
import Symbol_729 from './729.svg';
import Symbol_901 from './901.svg';
import Symbol_903 from './903.svg';
import Symbol_D01 from './D01.svg';
import Symbol_D04 from './D04.svg';
import Symbol_D05 from './D05.svg';
import Symbol_D06 from './D06.svg';
import Symbol_D07 from './D07.svg';
import Symbol_D08 from './D08.svg';
import Symbol_custom_1 from './custom_1.svg';
import Symbol_custom_2 from './custom_2.svg';
import Symbol_1SFA616903R1019 from './1SFA616903R1019.svg';
import Symbol_1SFA616903R1020 from './1SFA616903R1020.svg';
import Symbol_Frame_11 from './Frame_11.svg';
import Symbol_Frame_11_12 from './Frame_11_12.svg';
import Symbol_Frame_11_12_circle from './Frame_11_12_circle.svg';
import Symbol_Frame__21_22 from './Frame_21_22.svg';
import Symbol_Frame_31_32_33 from './Frame_31_32_33.svg';
import Symbol_Frame_images from './Frame_image.svg';
import Symbol_SK615562_87 from './SK615562_87.svg';
import Symbol_SK615562_88 from './SK615562_88.svg';
import Symbol_111_position_11 from './111_position_11.svg';
import Symbol_102_position_33 from './102_position_33.svg';
import Symbol_102_position_31 from './102_position_31.svg';
import Symbol_097_position_11 from './097_position_11.svg';
import Symbol_096_position_11 from './096_position_11.svg';
import Symbol_073_position_33 from './073_position_33.svg';
import Symbol_073_position_31 from './073_position_31.svg';
import Symbol_069_position_33 from './069_position_33.svg';
import Symbol_069_position_31 from './069_position_31.svg';
import Symbol_064_position_33 from './064_position_33.svg';
import Symbol_064_position_31 from './064_position_31.svg';
import Symbol_063_position_11 from './063_position_11.svg';
import Symbol_1SFA611940R1060 from './1SFA611940R1060.svg';
import Symbol_1SFA611930R1252 from './1SFA611930R1252.svg';
import Line from './Line.svg'
import Cancel from './Cancel.svg'
import Symbol_039_049 from './039-049.svg';
import Symbol_notext from './notext.svg';
import infoIconBlue from './info-circle-blue.svg'
import HelpCircle from './help-Circle.svg'
import Reports from './reports.svg';
import whiteInfoIcon from './whiteInfoicon.svg'
import deliveryOptionIcon from './deliverOption.png';
import NewDeliveryIcon from './NewDeliveryIcon.svg';
import NoteIcon from './NoteIcon.svg';
import support from "./support.svg";
export {
  accessoriesIcon,
  leafIcon,
  checkedIcon,
  addIcon,
  addIcon1,
  addIcon2,
  arrowBottomIcon,
  arrowBottomIcon1,
  arrowDownIcon,
  arrowLeftIcon,
  arrowLeftIcon1,
  arrowRightIcon,
  arrowRightIcon1,
  arrowRightIcon2,
  arrowTopIcon,
  arrowTopIcon1,
  arrowUpIcon,
  cartIcon,
  cartIcon1,
  cartAddIcon,
  categoriesIcon,
  categoriesIcon1,
  checkIcon,
  checkIcon1,
  checkIcon2,
  closeIcon,
  closeIcon1,
  collapsedIcon,
  copyIcon,
  deleteIcon,
  dotsIcon,
  downloadIcon,
  editIcon,
  errorIcon,
  expandedIcon,
  exportIcon,
  favoriteIcon,
  filterIcon,
  forwardArrowIcon,
  importIcon,
  infoIcon,
  linkedIcon,
  listIcon,
  listIcon1,
  listIcon2,
  listIcon3,
  listIcon4,
  logoIcon,
  menuIcon,
  menuIcon1,
  pinIcon,
  profileIcon,
  profileIcon1,
  resetIcon,
  searchIcon,
  searchIcon1,
  solutionsIcon,
  solutionsIcon1,
  sortIcon,
  starIcon,
  stockIcon,
  tileIcon,
  tipsIcon,
  tipsIcon1,
  uploadIcon,
  warningIcon,
  warningIcon1,
  windowsIcon,
  wrenchesIcon,
  CartIconNew,
  ABBLogo,
  ABBLogoPNG,
  calculatorIcon,
Language,
ABBRedLogo,
CartLogoNew,
VectorRightIconNew,
VectorCartLogoNew,
VectorArrowRightIconNew,
VectorMobileSearchIcon,
VectorMobileTreeViewIcon,
VectorMediaViewBlock,
VectorSearchArrowDownIcon,
VectorCounterMinusIcon,
VectorCounterPlusIcon,
DeleteIconNew,
ImportIconNew,
ExportIconNew,
DeleteWhiteIconNew,
EmptyStateIconNew,
CloseIconNew,
ResetIconNew,
ProductDeailedView,
ProductSimpleView,
MenuIconNew,
ProductMenuIconNew,
DuplicateIconNew,
EditIConNew,
TrashIconNew,
FilterIconNew,
PinIconNew,
ABBRedLogoPng,
MinusIconNewSvg,
MinusIconActive,
EmptySearchStateIcon,
WarningTriangleIconNew,
SettingsIconNew,
TrashWhiteIconNew,
MobileExcelImportIcon,
HelpImage,
InfoIconNew,
OpenInNewWindow,
OrangeWarningIconNew,
RedCheckMarkIconNew,
WhiteCartIconNew,
SelectedRadioIconNew,
NotSelectedRadioIconNew,
GreyFilterEmptyIconNew,
CloseLightIconNew,
GreyDeleteIconNew,
DownArrowIconNew,
SearchIconNew,
ResetSearchIconNew,
PathIndicatorNew,
ErrorIconNew,
placeHoderImage,
support,
closePopup,
linkedIconNew,
mobileClosePopup,
minusIcon,
addonsInfoIcon,
breadcrumIcon,
messageErrorIcon,
messageWarningIcon,
messageSuccessIcon,
productWarningIcon,
NewSearchIcon,
NewArrowTopIcon,
newExpandButton,
caretDownIconNew,
vectorArrowUpNew,
tickIconNew,
ABBLogoSVG,
readyAssemblyWaningIcon,
GlobalIconNew,
LanguageTickIcon,
deliveryOptionIcon,
Symbol_902,
Symbol_001,
Symbol_005,
Symbol_007,
Symbol_015,
Symbol_021,
Symbol_032,
Symbol_034,
Symbol_039,
Symbol_045,
Symbol_046,
Symbol_049,
Symbol_050,
Symbol_051,
Symbol_052,
Symbol_053,
Symbol_054,
Symbol_055,
Symbol_056,
Symbol_301,
Symbol_302,
Symbol_303,
Symbol_304,
Symbol_305,
Symbol_307,
Symbol_311,
Symbol_320,
Symbol_321,
Symbol_322,
Symbol_329,
Symbol_330,
Symbol_331,
Symbol_332,
Symbol_335,
Symbol_338,
Symbol_339,
Symbol_346,
Symbol_347,
Symbol_348,
Symbol_349,
Symbol_350,
Symbol_351,
Symbol_352,
Symbol_353,
Symbol_357,
Symbol_358,
Symbol_359,
Symbol_360,
Symbol_361,
Symbol_362,
Symbol_363,
Symbol_364,
Symbol_365,
Symbol_366,
Symbol_367,
Symbol_368,
Symbol_501,
Symbol_502,
Symbol_503,
Symbol_504,
Symbol_510,
Symbol_511,
Symbol_512,
Symbol_516,
Symbol_517,
Symbol_707,
Symbol_708,
Symbol_723,
Symbol_724,
Symbol_725,
Symbol_726,
Symbol_727,
Symbol_729,
Symbol_901,
Symbol_903,
Symbol_D01,
Symbol_D04,
Symbol_D05,
Symbol_D06,
Symbol_D07,
Symbol_D08,
Symbol_custom_1,
Symbol_custom_2,
Symbol_1SFA616903R1019,
Symbol_1SFA616903R1020,
Symbol_039_049,
Symbol_Frame_11,
Symbol_Frame_11_12,
Symbol_Frame_11_12_circle,
Symbol_Frame__21_22,
Symbol_Frame_31_32_33,
Symbol_Frame_images,
Symbol_519,
Symbol_520,
Symbol_518,
Symbol_515 ,
Symbol_514,
Symbol_420,
Symbol_SK615562_87,
Symbol_SK615562_88 ,
Symbol_111_position_11,
Symbol_102_position_33,
Symbol_102_position_31,
Symbol_097_position_11,
Symbol_096_position_11,
Symbol_073_position_33,
Symbol_073_position_31,
Symbol_069_position_33,
Symbol_069_position_31,
Symbol_064_position_33,
Symbol_064_position_31,
Symbol_063_position_11,
Symbol_1SFA611940R1060,
Symbol_1SFA611930R1252,
Line,
Cancel,
Symbol_notext,
infoIconBlue,
HelpCircle,
Reports,
whiteInfoIcon,
NewDeliveryIcon,
NoteIcon,
// arrowExpanderIcon,
// arrowExpandedIcon
redStarIcon
};